module.exports = __webpack_public_path__ + "static/media/Pie.5b854620.PNG";